import { render, staticRenderFns } from "./content-file.vue?vue&type=template&id=151fb04b&scoped=true&"
import script from "./content-file.vue?vue&type=script&lang=js&"
export * from "./content-file.vue?vue&type=script&lang=js&"
import style0 from "./content-file.vue?vue&type=style&index=0&id=151fb04b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151fb04b",
  null
  
)

export default component.exports